export const reportTitles = {
  AR_SUMMARY: { name: 'Accounts Receivable Summary', isGroupResult: false, isFastReportResult: true, reportFileName: 'AccountReceivableSummary',  filterRef: 'AR_FILTERS', isExportNA: true },
  AR_DETAILS: { name: 'Accounts Receivable Details', isGroupResult: false, isFastReportResult: true, reportFileName: 'AccountReceivableDetail', filterRef: 'AR_FILTERS', isExportNA: true },
  AP_SUMMARY: { name: 'Accounts Payable Summary', isGroupResult: false, isFastReportResult: true, reportFileName: 'AccountPayableSummary',  filterRef: 'AP_FILTERS', isExportNA: true },
  AP_DETAILS: { name: 'Accounts Payable Details', isGroupResult: false, isFastReportResult: true, reportFileName: 'AccountPayableDetail', filterRef: 'AP_FILTERS', isExportNA: true },
  INC_CUST_SUMMARY: { name: 'Income By Customer Summary', isGroupResult: false, isFastReportResult: true, reportFileName: 'IncomeByCustomerSummary', filterRef: 'INC_FILTERS', isExportNA: true },
  INC_CUST_DETAILS: { name: 'Income By Customer Details', isGroupResult: false, isFastReportResult: true, reportFileName: 'IncomeByCustomerDetail', filterRef: 'INC_FILTERS', isExportNA: true },
  EXP_VEND_SUMMARY: { name: 'Expense By Vendor Summary', isGroupResult: false, isFastReportResult: true, reportFileName: 'ExpenseByVendorSummary', filterRef: 'EXP_FILTERS', isExportNA: true },
  EXP_VEND_DETAILS: { name: 'Expense By Vendor Details', isGroupResult: false, isFastReportResult: true, reportFileName: 'ExpenseByVendorDetail', filterRef: 'EXP_FILTERS', isExportNA: true },
  CREDIT_MEMO_SUMMARY: { name: 'Credit Memo Summary', isGroupResult: false, isFastReportResult: false, reportFileName: null, filterRef: 'CREDIT_MEMO_FILTERS', isExportNA: false },
  CREDIT_MEMO_DETAILS: { name: 'Credit Memo Details', isGroupResult: true, isFastReportResult: false, reportFileName: null, filterRef: 'CREDIT_MEMO_FILTERS', isExportNA: true },
  INVENTORY_WORKSHEET: { name: 'Inventory Worksheet For Counts', isGroupResult: false, isFastReportResult: false, reportFileName: null, filterRef: 'INVENTORY_WORKSHEET_FILTERS', isExportNA: false },
  EMPLOYEE_SALES_COMMISSION_DETAILS: { name: 'Employee Sales Commission Details', isGroupResult: true, isFastReportResult: false, reportFileName: null, filterRef: 'EMPLOYEE_SALES_COMMISSION_DETAILS_FILTERS', isExportNA: false }
}

export const reportsList = [
  {
    title: 'Who owes you',
    reports: [
      {
        token: 'AR_SUMMARY',
        display: 'Accounts Receivable Summary'
      },
      {
        token: 'AR_DETAILS',
        display: 'Accounts Receivable Details'
      }
    ]
  },  
  {
    title: 'Sales and customers',
    reports: [
      {
        token: 'INC_CUST_SUMMARY',
        display: 'Income By Customer Summary'
      },
      {
        token: 'INC_CUST_DETAILS',
        display: 'Income By Customer Details'
      },
    ]
  },
  {
    title: 'What you owe',
    reports: [
      {
        token: 'AP_SUMMARY',
        display: 'Accounts Payable Summary'
      },
      {
        token: 'AP_DETAILS',
        display: 'Accounts Payable Details'
      },
    ]
  },
  {
    title: 'Expenses and vendors',
    reports: [
      {
        token: 'EXP_VEND_SUMMARY',
        display: 'Expense By Vendor Summary'
      },
      {
        token: 'EXP_VEND_DETAILS',
        display: 'Expense By Vendor Details'
      },
    ]
  },
  
  {
    title: 'Credit Memos',
    reports: [
      {
        token: 'CREDIT_MEMO_SUMMARY',
        display: 'Credit Memo Summary'
      },
      {
        token: 'CREDIT_MEMO_DETAILS',
        display: 'Credit Memo Details'
      },
    ]
  },
  {
    title: 'Inventory',
    reports: [
      {
        token: 'INVENTORY_WORKSHEET',
        display: 'Inventory Worksheet For Counts'
      }
    ]
  },
  {
    title: 'Commission Calculators',
    reports: [
      {
        token: 'EMPLOYEE_SALES_COMMISSION_DETAILS',
        display: 'Employee Sales Commission Details'
      },
      {
        token: 'EMPLOYEE_PURCHASE_COMMISSION_DETAILS',
        display: 'Employee Purchase Commission Details'
      }
    ]
  }
]

export const reportFilters = {
  AR_FILTERS: [
    {
      type: 'dateRange',
      label: 'Date Range',
      prop: '' // prop for date range should be specified in local
    },
    {
      type: 'suggestText',
      label: 'Customer',
      prop: 'company'
    },
    {
      type: 'salesRepDropdown',
      label: 'Sales Rep',
      prop: 'salesRep'
    }
  ],
  AP_FILTERS: [
    {
      type: 'dateRange',
      label: 'Date Range',
      prop: '' // prop for date range should be specified in local
    },
    {
      type: 'dropdown',
      label: 'Transaction Type',
      prop: 'transactionType',
      options: [
        { value: null, name: 'All' },
        { value: 'Purchase Order', name: 'Purchase Order' },
        { value: 'Work Order', name: 'Work Order' }
      ]
    },
    {
      type: 'suggestText',
      label: 'Vendor',
      prop: 'company'
    },
    {
      type: 'salesRepDropdown',
      label: 'Sales Rep',
      prop: 'salesRep'
    }
  ],
  INC_FILTERS: [
    {
      type: 'dateRange',
      label: 'Date Range',
      prop: '' // prop for date range should be specified in local
    },
    {
      type: 'suggestText',
      label: 'Customer',
      prop: 'company'
    },
    {
      type: 'salesRepDropdown',
      label: 'Sales Rep',
      prop: 'salesRep'
    },
    // {
    //   type: 'dropdown',
    //   label: 'Balance Status',
    //   prop: 'balanceStatus',
    //   options: [
    //     { value: null, name: 'All' },
    //     { value: 1, name: 'With Balance' },
    //     { value: 0, name: 'Without Balance' }
    //   ]
    // }
  ],
  EXP_FILTERS: [
    {
      type: 'dateRange',
      label: 'Date Range',
      prop: '' // prop for date range should be specified in local
    },
    {
      type: 'suggestText',
      label: 'Vendor',
      prop: 'company'
    },
    // {
    //   type: 'dropdown',
    //   label: 'Transaction Type',
    //   prop: 'transactionType',
    //   options: [
    //     { value: null, name: 'All' },
    //     { value: 'Purchase Order', name: 'Purchase Order' },
    //     { value: 'Work Order', name: 'Work Order' }
    //   ]
    // },
    {
      type: 'salesRepDropdown',
      label: 'Sales Rep',
      prop: 'salesRep'
    },
    {
      type: 'dropdown',
      label: 'Balance Status',
      prop: 'balanceStatus',
      options: [
        { value: null, name: 'All' },
        { value: 1, name: 'With Balance' },
        { value: 0, name: 'Without Balance' }
      ]
    }
  ],
  CREDIT_MEMO_FILTERS: [
    {
      type: 'dateRange',
      label: 'Date Range',
      prop: '' // prop for date range should be specified in local
    },
    {
      type: 'suggestText',
      label: 'Company',
      prop: 'company'
    },
    {
      type: 'dropdown',
      label: 'Type',
      prop: 'isVendor',
      options: [
        { value: null, name: 'All' },
        { value: 0, name: 'Credit Memo' },
        { value: 1, name: 'Vendor Credits' }
      ]
    },
    {
      type: 'dropdown',
      label: 'Transaction',
      prop: 'withAppliedTransaction',
      options: [
        { value: null, name: 'All' },
        { value: 1, name: 'With Transaction' },
        { value: 0, name: 'Without Transaction' }
      ]
    }
  ],
  INVENTORY_WORKSHEET_FILTERS: [
    {
      type: 'text',
      label: 'Warehouse',
      prop: 'warehouseName'
    },
  ],
  EMPLOYEE_SALES_COMMISSION_DETAILS_FILTERS: [
    {
      type: 'dateRange',
      label: 'Date Range',
      prop: '' // prop for date range should be specified in local
    },
    {
      type: 'suggestText',
      label: 'Customer',
      prop: 'company'
    },
    {
      type: 'salesRepDropdown',
      label: 'Sales Rep',
      prop: 'salesRep'
    }
  ]
}